import { ca } from '@cian/analytics';
import { useState, useCallback } from 'react';

/**
 * Маппер поля key из объекта IService в строку el для аналитики
 * v1 и v2 - версии блока "Сервисы".
 * Для удобства отладки указал версию (1, 2 или обе), в которых отображается сервис и его отображаемое название
 * */
export function getLabel(key: string): string {
  switch (key) {
    case 'evaluation': //v1 Оценка Циан & v2 Оценка
      return 'kalkulator_nedvizhimosti';
    case 'mortgage': //v1 & v2 Ипотека
      return 'mortgage';
    case 'journal': //v1 Журнал Циан
      return 'magazine';
    case 'mortgageCalculator': //v1 Калькулятор ипотеки & v2 Ипотечный калькулятор
      return 'mortgage_calculator';
    case 'consumerCredit': //v1 Потребительский кредит & v2 Потреб.кредит
      return 'consumer_credit';
    case 'leads': //v1 Помощь риелтора
      return 'application_to_realtor';
    case 'agentCatalog': //v1 Каталог риелторов
      return 'agent_catalog';
    case 'dealRent': //v1 Сдать квартиру & v2 Сдай/Сними
      return 'deal_rent';
    case 'saleRent': //v1 Куплю\Сниму
      return 'buy_rent';
    case 'legalCheck': //v2 Проверка жилья
      return 'legal_check';
    case 'analizRynka': //v2 Аналитика бизнесу
      return 'market_analiz';
    case 'selectionRealtor': //v2 Подбор риелтора
      return 'podbor_rieltora';
    case 'investCalculator': //v2 Инвест.калькулятор
      return 'invest_calculator';
    default:
      return key;
  }
}

export const trackServiceClick = (key: string, isRedesign = false) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'mobile_main_page',
    action: 'click_services',
    label: isRedesign ? key : getLabel(key),
  });
};

export const trackServiceShow = (key: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'mobile_main_page',
    action: 'show_sopr',
    label: `services_${getLabel(key)}`,
  });
};

export const trackServiceShowNew = (key: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'mobile_main_page',
    action: 'show_sopr_services',
    label: key,
  });
};

/** Позволяет трекать аналитику только 1 раз */
export const useTrackServiceShow = () => {
  const [tracked, setTracked] = useState<string[]>([]);

  return useCallback(
    (key: string) => {
      if (!tracked.includes(key)) {
        setTracked(tracked.concat(key));
        trackServiceShow(key);
      }
    },
    [tracked],
  );
};
